import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'individualESC',
    label: 'Individual ESC Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
